import api from "../../../js/api";

export default {
	state: {
		jobs: [],
	},
	mutations: {
		setJobList(state, jobs) {
			state.jobs = jobs;
		},
	},
	actions: {
		apiGetJobList(context, showloader = true) {
			api.get("job/list", null, showloader)
				.then(
					response => {
						context.commit('setJobList', response.data.data.sort((a, b) => {
								if (a.updated_at > b.updated_at) {
									return -1;
								}
								if (a.updated_at > b.updated_at) {
									return 1;
								}
								return 0;
							})
						)
					}
				);
		},
	},
	getters: {
		getJobList(state) {
			return state.jobs;
		},
	}
}



// WEBPACK FOOTER //
// ./src/storage/modules/enterprise/job.js